import React, { useEffect } from "react";
import {
  Alert,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@mui/material";
import { blue } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import ProfessionalCovenants from "src/Professional/ProfessionalCovenants";
import ProfessionalName from "src/Professional/ProfessionalName";
import ProfessionalPhoto from "src/Professional/ProfessionalPhoto";
import ProfessionalSpecialities from "src/Professional/ProfessionalSpecialities";
import { serializeDateFormatLong } from "src/shared/global/helpers";
import { hourSelectedState } from "src/store/reservation/reservationState";
import useSEO from "src/Hooks/useSEO";
import { resumeWaitListState } from "./state/atoms";
import { InfoOutlined } from "@mui/icons-material";
import Informacion from "./components/Informacion";
//import ReactGA from 'react-ga';

const SuccessWaitList = () => {
  //const history = useNavigate();
  const resumeWaitList = useRecoilValue(resumeWaitListState);

  const navigate = useNavigate();

  useSEO({ title: "Inscripción exitosa" });

  useEffect(() => {
    if (resumeWaitList === null) {
      //history.push(process.env.REACT_APP_ROOT_SERVER_PATH)
      navigate(process.env.REACT_APP_ROOT_SERVER_PATH);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resumeWaitList]);

  return (
    <Grid container>
      <Alert sx={{ my: 2 }}>
        Hemos enviado un correo electrónico a <b>{resumeWaitList?.Email}</b> con
        la confirmación de su inscripción de lista de espera (Si no lo encuentra
        en su bandeja, revise su bandeja de Spam).
      </Alert>

      <Grid container spacing={{ xs: 1, md: 2 }}>
        <Grid item xs={12} md={7}>
          <Card sx={{ mb: 1 }}>
            <CardHeader
              title="Fechas de Vigencia"
              titleTypographyProps={{ variant: "h3" }}
            />
            <CardContent
              sx={{
                display: "flex",
                alignItems: "center", // Alinea verticalmente los elementos
                justifyContent: "flex-start", // Alinea horizontalmente los elementos
                flexDirection: "row",
                gap: "1rem", // Espaciado uniforme entre los elementos
              }}
            >
              <span style={{ fontSize: "3rem" }}>🗓</span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem", // Espaciado uniforme entre líneas
                }}
              >
                <p
                  style={{
                    fontSize: "1.2rem",
                    textTransform: "capitalize",
                    margin: 0,
                  }}
                >
                  {serializeDateFormatLong(resumeWaitList?.FechaIni, false)}
                </p>
                <p
                  style={{
                    fontSize: "1.2rem",
                    textTransform: "capitalize",
                    margin: 0,
                  }}
                >
                  {serializeDateFormatLong(resumeWaitList?.FechaFin, false)}
                </p>
              </div>
            </CardContent>
          </Card>

          <Card sx={{ mb: 1 }}>
            <CardHeader
              title="Profesional / Especialidad"
              titleTypographyProps={{ variant: "h3" }}
            ></CardHeader>
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
              <Grid
                item
                container
                md={12}
                style={{
                  marginLeft: 12,
                }}
              >
                <Grid item md={12}>
                  <ProfessionalName
                    fontSize={20}
                    nameProfessional={resumeWaitList?.especialista}
                  />
                  <ProfessionalSpecialities
                    fontSize={16}
                    specialities={resumeWaitList?.especialidad}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={5}>
          <Informacion />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SuccessWaitList;
